module.exports = __webpack_public_path__ + "fonts/poppins-semibold-webfont.2a3b5b39.woff";